module.exports = __webpack_public_path__ + "img/Hand_31_05_19.8840e73e.png";